import React from 'react';

import { RxMagicWand } from 'react-icons/rx';

import ApartmentIcon from '@mui/icons-material/Apartment';
import { Box, Stack, Typography } from '@mui/material';

import { useTheme } from 'hooks/useTheme';

interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  value?: string;
  subtitle?: string | null;
  variant?: 'default' | 'highlighted' | 'editable';
  iconColor?: string;
  titleColor?: string;
  valueColor?: string;
  subtitleColor?: string;
  backgroundColor?: string;
  borderColor?: string;
  padding?: number;
  spacing?: number;
  showWizardIcon?: boolean;
  slug?: string | null;
}

const InfoCard: React.FC<InfoCardProps> = ({
  icon,
  title,
  value,
  subtitle,
  variant = 'default',
  iconColor,
  titleColor,
  valueColor,
  subtitleColor,
  backgroundColor,
  borderColor,
  padding = 0.5,
  spacing = 1,
  slug,
}) => {
  const theme = useTheme();

  const defaultColors = {
    icon: iconColor || theme.theme.primary,
    title: titleColor || theme.theme.text.primary,
    value: valueColor || theme.theme.primary,
    subtitle: subtitleColor || theme.theme.text.secondary,
    background: backgroundColor || theme.theme.background.secondary,
    border: borderColor || theme.theme.primary,
  };

  const highlightedColors = {
    icon: iconColor || theme.theme.primary,
    title: titleColor || theme.theme.primary,
    value: valueColor || theme.theme.primary,
    subtitle: subtitleColor || theme.theme.text.primary,
    background: backgroundColor || `${theme.theme.primary}35`,
    border: borderColor || theme.theme.primary,
  };

  const colors = variant === 'highlighted' ? highlightedColors : defaultColors;

  if (slug === 'professionalTrajectory') {
    return;
  }

  return (
    <Box
      sx={{
        backgroundColor: colors.background,
        borderLeft: subtitle ? `2px solid ${colors.border}` : 'none',
        borderRadius: 2,
        padding: `${padding * 2}rem ${padding}rem`,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        gap: 0.5,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{
          marginLeft: spacing,
        }}
      >
        {!subtitle && (
          <>
            {/* <Box
              sx={{
                color: colors.icon,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 10,
                width: 10,
                height: 10,
              }}
            >
              {icon}
            </Box> */}
            <Typography
              variant="body1"
              sx={{
                color: colors.title,
                fontWeight: 'bold',
                fontSize: '1rem',
                lineHeight: 1.2,
              }}
            >
              {title}:
            </Typography>
          </>
        )}
        {value && (
          <Typography
            variant="body1"
            sx={{
              color: subtitle ? colors.icon : colors.title,
              fontSize: '1rem',
              fontWeight: subtitle ? 900 : 400,
            }}
          >
            {subtitle ? value.split('|')[0]?.trim() : value}
          </Typography>
        )}
        {variant === 'highlighted' && (
          <Box
            sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              color: theme.theme.primary,
              fontSize: '1rem',
            }}
          >
            <RxMagicWand />
          </Box>
        )}
      </Stack>

      {subtitle && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.2}
          sx={{
            marginLeft: spacing,
            alignItems: 'flex-end',
          }}
        >
          <Box
            sx={{
              color: colors.title,
              display: 'flex',
            }}
          >
            <ApartmentIcon sx={{ fontSize: 14 }} />
          </Box>
          <Typography
            variant="body2"
            sx={{
              color: colors.title,
              fontSize: '1rem',
              lineHeight: 1,
            }}
          >
            {subtitle && subtitle.includes('|') ? subtitle.split('|')[1]?.trim() : subtitle}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default InfoCard;
